export default [
  {
    portalGroup: 'collab.admin',
    path: 'pendingList',
    name: 'PendingList',
    component: () => import('./PgPendingList'),
    meta: {
      title: '代辦事項管理',
      authenticated: true,
      roles: ['SA', 'PA', 'VA', 'PAP', 'PAL', 'PAC', 'PAA']
    }
  }
]
